import { render, staticRenderFns } from "./ResetPswd.vue?vue&type=template&id=1debb2ec"
import script from "./ResetPswd.vue?vue&type=script&lang=js"
export * from "./ResetPswd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports